import type { ErrorResponse } from '@app/src/types/api'

const joinValidationItems = (validation: ErrorResponse['validation']): string => {
  const items = validation?.items
  if (!items?.length) {
    return ''
  }

  return ` - ${items.map(item => `${item.name}: ${item.message}`).join(' | ')}`
}

/**
 * The human-readable half of an API failure, used as the exception message so an
 * unhandled rejection arrives in Sentry with a title that names what went wrong.
 */
export const extractErrorMessage = (statusCode: number, body: ErrorResponse | null): string => {
  if (!body) {
    return 'API request failed'
  }

  if (body.message) {
    return body.message + joinValidationItems(body.validation)
  }

  return body.errorCode ?? `HTTP ${statusCode} error`
}
